// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"585":"TikTokApplication","593":"InstagramApplication"}[chunkId] || chunkId) + "." + {"337":"7a03b908","585":"68e44b4e","593":"818d83f9","656":"79b30dcb","788":"4854b899"}[chunkId] + ".js";
};